var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcPassword = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3238 29.3905V37.1505C36.3238 39.8031 34.1734 41.9535 31.5208 41.9535C28.8682 41.9535 26.7178 39.8031 26.7178 37.1505V29.3905C26.7178 17.7136 36.1226 8.19195 47.7552 8.00268L48.1085 8C59.7856 8 69.3069 17.4049 69.4962 29.0373L69.499 29.3905V37.1505C69.499 39.8031 67.3487 41.9535 64.6961 41.9535C62.0434 41.9535 59.8931 39.8031 59.8931 37.1505V29.3905C59.8931 22.9575 54.7117 17.7118 48.3031 17.6075L48.1085 17.6059C41.6103 17.6059 36.3238 22.8925 36.3238 29.3905Z",
    fill: "#FFD666"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter0_i_463_17784)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3238 29.3905V41.9535H26.7178V29.3905C26.7178 17.7136 36.1226 8.19195 47.7552 8.00268L48.1085 8C59.7856 8 69.3069 17.4049 69.4962 29.0373L69.499 29.3905V41.9535H59.8931V29.3905C59.8931 22.9575 54.7117 17.7118 48.3031 17.6075L48.1085 17.6059C41.6103 17.6059 36.3238 22.8925 36.3238 29.3905Z",
    fill: "white",
    fillOpacity: 0.04
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.2169 68.127C79.2169 79.105 70.3177 88.0042 59.3399 88.0042H36.8771C25.8992 88.0042 17 79.105 17 68.127V47.8765C17 43.3052 20.7056 39.5996 25.2769 39.5996H48.1075L48.1085 39.6002L70.94 39.5996C75.5113 39.5996 79.2169 43.3052 79.2169 47.8765V68.127ZM44.5109 66.8616C44.5109 68.8487 46.1218 70.4596 48.1089 70.4596H49.5008C50.7192 70.4596 51.7069 69.4719 51.7069 68.2535C51.7069 67.3446 52.2769 66.5484 53.0652 66.096C53.8915 65.6217 54.6536 65.0285 55.3191 64.3287C57.2141 62.328 58.1785 59.7137 58.0344 56.9599C57.7658 51.7836 53.4962 47.6482 48.3104 47.5429C48.289 47.5425 48.2677 47.5425 48.2463 47.5425L48.112 47.544C48.1112 47.544 48.1104 47.5438 48.1097 47.5435C48.109 47.5431 48.1083 47.5429 48.1075 47.5429C43.4654 47.5435 38.9555 51.1219 38.26 56.1011C38.189 56.6454 38.6269 57.1036 39.1759 57.1036H45.3796C45.3847 57.1036 45.3889 57.0994 45.3889 57.0943C45.4151 56.9069 45.4596 56.7262 45.5206 56.554L45.5412 56.4977C45.5512 56.4713 45.5616 56.4451 45.5724 56.4191L45.5999 56.3552C45.664 56.2111 45.74 56.074 45.8267 55.9449C45.9407 55.7751 46.0732 55.6193 46.2213 55.4801C46.3192 55.3881 46.4239 55.3033 46.5346 55.2265L46.6047 55.1794L46.6652 55.1413L46.7087 55.1152L46.7571 55.0875C46.7824 55.0734 46.8079 55.0596 46.8338 55.0462C46.8792 55.0227 46.9253 55.0004 46.9722 54.9793L47.059 54.9422C47.1037 54.9239 47.1491 54.9068 47.195 54.8909L47.2544 54.871C47.3302 54.8466 47.4076 54.8254 47.4862 54.8075C47.5258 54.7985 47.5658 54.7903 47.606 54.783L47.6634 54.7732L47.7212 54.7646L47.7882 54.7562C47.8304 54.7514 47.8729 54.7475 47.9156 54.7446L47.9774 54.7411L48.0395 54.7389L48.1076 54.7381C48.1082 54.7381 48.1087 54.7386 48.1087 54.7393C48.1087 54.7399 48.1092 54.7404 48.1098 54.7404L48.1665 54.7387C49.572 54.7676 50.7762 55.9285 50.8481 57.3342C50.8865 58.0968 50.6226 58.8212 50.0997 59.3731L50.0514 59.4223L49.9918 59.4801C49.4961 59.9464 48.8633 60.2079 48.1845 60.2259L48.1095 60.2269L47.4332 60.2268C45.8192 60.2268 44.5109 61.5351 44.5109 63.1491V66.8616ZM48.1087 72.9743C48.1087 72.9745 48.1088 72.9745 48.1087 72.9743C46.151 72.9744 44.5635 74.561 44.5635 76.5185C44.5635 78.4758 46.1503 80.0628 48.1078 80.0629C48.1079 80.0628 48.1078 80.0628 48.1078 80.0629L48.1089 80.0627L48.1724 80.0621C50.1001 80.0278 51.6521 78.4544 51.6521 76.5183C51.6521 74.5612 50.0657 72.9748 48.1087 72.9743Z",
    fill: "#3C6FF5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter1_i_463_17784)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.2169 68.127C79.2169 79.105 70.3177 88.0042 59.3399 88.0042H36.8771C25.8992 88.0042 17 79.105 17 68.127V47.8765C17 43.3052 20.7056 39.5996 25.2769 39.5996H48.1075L48.1085 39.6002L70.94 39.5996C75.5113 39.5996 79.2169 43.3052 79.2169 47.8765V68.127ZM44.5109 66.8616C44.5109 68.8487 46.1218 70.4596 48.1089 70.4596H49.5008C50.7192 70.4596 51.7069 69.4719 51.7069 68.2535C51.7069 67.3446 52.2769 66.5484 53.0652 66.096C53.8915 65.6217 54.6536 65.0285 55.3191 64.3287C57.2141 62.328 58.1785 59.7137 58.0344 56.9599C57.7658 51.7836 53.4962 47.6482 48.3104 47.5429C48.289 47.5425 48.2677 47.5425 48.2463 47.5425L48.112 47.544C48.1112 47.544 48.1104 47.5438 48.1097 47.5435C48.109 47.5431 48.1083 47.5429 48.1075 47.5429C43.4654 47.5435 38.9555 51.1219 38.26 56.1011C38.189 56.6454 38.6269 57.1036 39.1759 57.1036H45.3796C45.3847 57.1036 45.3889 57.0994 45.3889 57.0943C45.4151 56.9069 45.4596 56.7262 45.5206 56.554L45.5412 56.4977C45.5512 56.4713 45.5616 56.4451 45.5724 56.4191L45.5999 56.3552C45.664 56.2111 45.74 56.074 45.8267 55.9449C45.9407 55.7751 46.0732 55.6193 46.2213 55.4801C46.3192 55.3881 46.4239 55.3033 46.5346 55.2265L46.6047 55.1794L46.6652 55.1413L46.7087 55.1152L46.7571 55.0875C46.7824 55.0734 46.8079 55.0596 46.8338 55.0462C46.8792 55.0227 46.9253 55.0004 46.9722 54.9793L47.059 54.9422C47.1037 54.9239 47.1491 54.9068 47.195 54.8909L47.2544 54.871C47.3302 54.8466 47.4076 54.8254 47.4862 54.8075C47.5258 54.7985 47.5658 54.7903 47.606 54.783L47.6634 54.7732L47.7212 54.7646L47.7882 54.7562C47.8304 54.7514 47.8729 54.7475 47.9156 54.7446L47.9774 54.7411L48.0395 54.7389L48.1076 54.7381C48.1082 54.7381 48.1087 54.7386 48.1087 54.7393C48.1087 54.7399 48.1092 54.7404 48.1098 54.7404L48.1665 54.7387C49.572 54.7676 50.7762 55.9285 50.8481 57.3342C50.8865 58.0968 50.6226 58.8212 50.0997 59.3731L50.0514 59.4223L49.9918 59.4801C49.4961 59.9464 48.8633 60.2079 48.1845 60.2259L48.1095 60.2269L47.4332 60.2268C45.8192 60.2268 44.5109 61.5351 44.5109 63.1491V66.8616ZM48.1087 72.9743C48.1087 72.9745 48.1088 72.9745 48.1087 72.9743C46.151 72.9744 44.5635 74.561 44.5635 76.5185C44.5635 78.4758 46.1503 80.0628 48.1078 80.0629C48.1079 80.0628 48.1078 80.0628 48.1078 80.0629L48.1089 80.0627L48.1724 80.0621C50.1001 80.0278 51.6521 78.4544 51.6521 76.5183C51.6521 74.5612 50.0657 72.9748 48.1087 72.9743Z",
    fill: "white",
    fillOpacity: 0.04
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_463_17784",
    x: 24.7178,
    y: 6,
    width: 44.7812,
    height: 35.9531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_463_17784"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_463_17784",
    x: 15,
    y: 37.5996,
    width: 64.2168,
    height: 50.4043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_463_17784"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcPassword);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_password.cde16f5cf43e97b734ae2c187ede221a.svg";